import axios from 'axios'
// import request from '@/utils/request'

export function getWxConfig (data) {
  return axios({
    url: process.env.BASE_URL + '/wechat/publicPlatformConfig',
    // url: 'https://api.ysintelligent.com/wechat/publicPlatformConfig',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      'data': JSON.stringify({
        ...data
      })
    }
  })
}

// export function getWxConfig () {
//   return axios({
//     url: 'https://d.dev.fzzht.com/php/',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     method: 'get',
//     data: {
//       // 'data': JSON.stringify({
//       //   ...data
//       // })
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/api/wxConfig.js